/**
 * Initial form state
 */
export const initialFormState = {
  name: "",
  email: "",
  mobile: "",
  product: "",
  serial: "",
  invoiceNumber: "",
  purchaseDate: "",
  pincode: "",
  city: "",
  state: "",
  consent: false,
};

/**
 * Product options for dropdown
 */
export const productOptions = [
  { label: "Select Product", value: "" },
  { label: "Electric Scalp Massager", value: "electric-scalp-massager" },
  { label: "Gun Massager", value: "gun-massager" },
  { label: "Mixer Grinder 3 Jar", value: "mixer-grinder-3-jar" },
  { label: "Mixer Grinder 4 Jar", value: "mixer-grinder-4-jar" },
  { label: "Infrared Cook Top", value: "infrared-cook-top" },
  { label: "Air Fryer 4.2L, Digital", value: "air-fryer-4.2l-digital" },
  { label: "Electric Kettle", value: "electric-kettle" },
  { label: "Ceiling Fan - Entry", value: "ceiling-fan-entry" },
  { label: "Bldc Fan - Entry", value: "bldc-fan-entry" },
  {
    label: "Heater - Portable below 1000 INR",
    value: "heater-portable-below-1000-inr",
  },
  {
    label: "Smart Watch - Entry Level Only below 1000 INR",
    value: "smart-watch-entry-level-below-1000-inr",
  },
  { label: "Nutribullet 500W", value: "nutribullet-500w" },
];

/**
 * Validation rules for form fields
 */
export const validationRules = {
  name: (v) => v.trim() !== "" || "Name is required",
  email: (v) =>
    /^\S+@\S+\.\S+$/.test(v) ? true : "Please enter a valid email address",
  mobile: (v) =>
    /^\d{10}$/.test(v)
      ? true
      : "Mobile number must be 10 digits (numbers only)",
  product: (v) => v !== "" || "Please select a product",
  serial: (v) =>
    /^[A-Za-z0-9]+$/.test(v.trim())
      ? true
      : v.trim() === ""
      ? "Product Serial Number is required"
      : "Product Serial Number must be alphanumeric",
  purchaseDate: (v) => v !== "" || "Date of Purchase is required",
  invoiceNumber: (v) =>
    /^[A-Za-z0-9]+$/.test(v.trim())
      ? true
      : v.trim() === ""
      ? "Invoice Number is required"
      : "Invoice Number must be alphanumeric",
  pincode: (v) => (/^\d{6}$/.test(v) ? true : "City Pin code must be 6 digits"),
};

/**
 * Fetch city and state from pincode
 * @param {string} pincode - 6 digit pincode
 * @returns {Promise<Object>} City, state, and error info
 */
export const fetchCityState = async (pincode) => {
  if (!/^\d{6}$/.test(pincode)) {
    return { city: "", state: "", pincodeError: "Your pin code is wrong" };
  }

  try {
    const res = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
    const data = await res.json();

    if (
      Array.isArray(data) &&
      data[0].Status === "Success" &&
      data[0].PostOffice &&
      data[0].PostOffice.length > 0
    ) {
      const postOffice = data[0].PostOffice[0];
      return {
        city: postOffice.District,
        state: postOffice.State,
        pincodeError: "",
      };
    }

    return { city: "", state: "", pincodeError: "Your pin code is wrong" };
  } catch {
    return { city: "", state: "", pincodeError: "Your pin code is wrong" };
  }
};

/**
 * Validate all form fields
 * @param {Object} form - Form data
 * @param {Object} errors - Current errors
 * @returns {Object} New errors object
 */
export const validateAllFields = (form, errors) => {
  const newErrors = {};
  const fieldsToValidate = [
    "name",
    "email",
    "mobile",
    "product",
    "serial",
    "invoiceNumber",
    "purchaseDate",
    "pincode",
  ];

  for (let key of fieldsToValidate) {
    if (validationRules[key]) {
      const isValid = validationRules[key](form[key]);
      if (isValid !== true) {
        newErrors[key] = isValid;
      }
    }
  }

  // Special case for pincode
  if (
    form.pincode &&
    form.pincode.length === 6 &&
    (!/^\d{6}$/.test(form.pincode) ||
      (errors.pincode === "Your pin code is wrong" && form.city === ""))
  ) {
    newErrors.pincode = "Your pin code is wrong";
  }

  return newErrors;
};
